import React from 'react';
import inmoLogo2 from '../../assets/images/inmoLogo2.png';
import profileIcon from '../../assets/images/interface/person-circle-outline.svg';
import InputSearch from '../InputSearch';
import { Link } from 'react-router-dom';

export default function HomeHeader({ goBack, goToProfile }) {
  return (
    <div className="map-header">
      <div className="map-header-logo-container">
        <Link to="/loteamientos">
          <img className="map-header-logo" src={inmoLogo2} alt="inmo" />
        </Link>
      </div>
      <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '400px' }}>
        <div>
          <InputSearch className="map-input mobile-noDisplay" mode="header" showText={false} />
        </div>
        <div onClick={goToProfile} className="map-header-profile">
          {localStorage.getItem("inmo_access_token") ? (
            <img src={profileIcon} width="32px" alt="profile"></img>
          ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 600,
                }}
              >
                Ingresar
              </div>
            )}
        </div>
      </div>
    </div>

  );
}
